import Vue from 'vue'
import Router from 'vue-router'
import Map from './views/Map.vue'

Vue.use(Router)

export default new Router({
    base: '/map/',
    routes: [
        {
            path: '/:fuel?/:country?/:region?/:province?/:station_slug?',
            name: 'home',
            component: Map
        }
    ]
})
